import type { Service } from "@kappa-v2/contracts";

// Chiavi i18n dei metodi di pagamento dei soci (come in produzione: form.payment.*)
export const PAYMENT_TYPES = [
  "form.payment.cash",
  "form.payment.bankTransfer",
  "form.payment.pos",
  "form.payment.electronicPayment"
];

// Frequenze dei servizi ricorrenti (abbonabili da un socio come quota periodica).
const RECURRING_FREQUENCIES = new Set([
  "form.paymentFrequency.mothly_fee",
  "form.paymentFrequency.yearly_fee",
  "form.paymentFrequency.weekly_fee"
]);

export function isRecurringService(service: Service): boolean {
  return RECURRING_FREQUENCIES.has(service.paymentFrequency);
}
